import { S3Img, S3ImgProps } from '../s3-img';
import { getTournamentPath } from './get-path';

export const S3TournamentImg = function S3UserImg({
  ref,
  tournamentId,
  s3Key,
  ...rest
}: {
  tournamentId: string;
  s3Key?: string;
  ref?: React.Ref<HTMLImageElement>;
} & Omit<S3ImgProps, 'path'>) {
  return (
    <S3Img
      ref={ref}
      path={s3Key ? getTournamentPath(tournamentId, s3Key) : undefined}
      {...rest}
    />
  );
};
